// extracted by mini-css-extract-plugin
export var blue = "_z-g";
export var brand = "_z-c";
export var darkGrey = "_z-f";
export var disabled = "_z-6";
export var disabledSubtle = "_z-7";
export var error = "_z-8";
export var green = "_z-h";
export var grey = "_z-e";
export var icon = "_z-0";
export var inherit = "_z-b";
export var lightGrey = "_z-d";
export var orange = "_z-j";
export var pink = "_z-l";
export var primary = "_z-1";
export var purple = "_z-m";
export var quaternary = "_z-4";
export var quinary = "_z-5";
export var red = "_z-k";
export var secondary = "_z-2";
export var success = "_z-a";
export var tertiary = "_z-3";
export var warning = "_z-9";
export var white = "_z-n";
export var yellow = "_z-i";